import { t } from '@/plugins/i18n'
export const b2bEditableTabs = [
  { label: '已授权', value: 1 }
]

export const storeColumns:any = [
  {
    label: t('店铺名'),
    prop: 'customerShopName',
    align: 'center',
    slotName: 'customerShopName',
    minWidth: 200
  },
  {
    label: t('店铺URL'),
    prop: 'customerShopUrl',
    align: 'center',
    slotName: 'customerShopUrl',
    minWidth: 200
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center'
  },
  {
    label: t('API状态'),
    prop: 'customerShopAuthStatus',
    align: 'center',
    slotName: 'customerShopAuthStatus',
    slotHeadName: 'customerShopAuthStatusHead',
    width: 150
  },
  {
    label: t('店铺钱包可用余额'),
    prop: 'availableAmount',
    align: 'center',
    slotName: 'availableAmount'
  },
  {
    label: t('店铺账号'),
    prop: 'activeSubAccountFlag',
    align: 'center',
    slotName: 'activeSubAccountFlag',
    slotHeadName: 'activeSubAccountFlagHead',
    width: 180
  }
  // {
  //   label: t('api权限'),
  //   prop: 'customerShopPermission',
  //   align: 'center',
  //   slotName: 'customerShopPermission',
  // }
]

export const tableConfig = {
  showHandler: true,
  setHeight: true
}
